/**
 * Returns true if the user is using a Chromebook.
 *
 * Used for gathering metrics and conditionally reducing
 * performance demands on the user's device.
 */
export function isChromebook() {
    return /CrOS/.test(navigator.userAgent);
}
